import axios from 'axios';

/* Posts basket positions one after the other and tells which flavours went
   through; used by "Add to basket" in quick order and by "Order again".

   The dashboard does not post through the ProductListProvider's addToBasket.
   That one fires one mutate() per flavour on a single useMutation, and TanStack
   runs the per-call onSuccess only for the last call, so it cannot tell which
   flavours went through: a failed earlier post still cleared its quantity, and
   after a failed last post a second click posted the successful flavours again,
   while the server adds quantities up. Parallel posts can also create several
   baskets. Here the positions go one after the other, and a failed post is
   counted instead of ending the run. */
export async function addBasketPositions(
  positions: { flavourId: number; quantity: number }[]
): Promise<{ succeeded: number[]; failed: number }> {
  const succeeded: number[] = [];
  let failed = 0;
  for (const { flavourId, quantity } of positions) {
    try {
      await axios.post(
        `/api/onlineshop/basket-positions/${flavourId}/${quantity}`
      );
      succeeded.push(flavourId);
    } catch (error) {
      failed += 1;
    }
  }

  return { succeeded, failed };
}
